<template>
  <transition name="slide-fade">
    <div v-if="showMsg" id="cookies-warning" :class="{'active': details}">
      <div class="btns">
        <button type="button" @click="setMsgCookie(false)">
          <slot name="btn-selected">ACCEPT SELECTED</slot>
        </button>
        <button type="button" @click="acceptAll()">
          <slot name="btn-all">ACCEPT ALL</slot>
        </button>
      </div>

      <transition name="height">
        <div v-if="viewportWidth>575 && viewportHeight>630 || !details">
          <slot name="info">
            <h6>THIS WEBSITE USES COOKIES</h6>
            <p>
              We use cookies for two reasons. First, we use cookies that are strictly necessary for the
              operation
              and security of the website and second, we use cookies to identify you and analyze our
              traffic
              provided that you have given your permission by checking the box “Statistics”.
            </p>
          </slot>
        </div>
      </transition>

      <slot name="checkboxes">
        <div class="checkboxes">
          <div class="checkbox-wrapper disabled" @click="alert(alertMsg)">
            <label for="necessary">
              <span class="checkbox-text">NECESSARY</span>
              <input id="necessary" v-model="cookies.necessary" type="checkbox" disabled />
              <span class="checkbox"></span>
            </label>
          </div>
          <div class="checkbox-wrapper">
            <label for="statistics">
              <span class="checkbox-text">STATISTICS</span>
              <input id="statistics" v-model="cookies.statistics" type="checkbox" />
              <span class="checkbox"></span>
            </label>
          </div>
        </div>
      </slot>

      <button
        type="button"
        @click="toggleDetails()"
        class="btn-details"
        :class="{'active': details}"
      >
        <slot name="btn-details">
          <span>MORE DETAILS</span>
        </slot>
      </button>

      <div class="details">
        <div class="tabs">
          <div class="tabs-btns">
            <button type="button" class="tab-btn" :class="{'active': tab===1}" @click="tab=1">
              <slot name="tab-1">COOKIE DECLARATION</slot>
            </button>
            <button type="button" class="tab-btn" :class="{'active': tab===2}" @click="tab=2">
              <slot name="tab-2">ABOUT COOKIES</slot>
            </button>
          </div>

          <div class="tab-content">
            <div v-if="tab===1" class="tabs-hor">
              <div class="tabs-hor-btns">
                <button
                  type="button"
                  class="tab-btn-hor"
                  :class="{'active': tabHor===1}"
                  @click="tabHor=1"
                >
                  <slot name="tab-1">NECESSARY</slot>
                </button>
                <button
                  type="button"
                  class="tab-btn-hor"
                  :class="{'active': tabHor===2}"
                  @click="tabHor=2"
                >
                  <slot name="tab-2">STATISTICS</slot>
                </button>
              </div>

              <div class="tab-content-hor">
                <div v-if="tabHor===1" v-bar="{preventParentScroll: true}" class="h-100">
                  <div>
                    <slot name="details-necessary">
                      <p>
                        Necessary cookies are used to provide and protect our services while
                        providing a swift and safer browsing experience by enabling basic
                        functions
                        like page navigation. The website cannot function properly without these
                        cookies.
                      </p>
                    </slot>
                  </div>
                </div>

                <div v-if="tabHor===2" v-bar="{preventParentScroll: true}" class="h-100">
                  <div>
                    <slot name="details-statistics">
                      <h6>STATISTICS</h6>
                    </slot>
                  </div>
                </div>
              </div>
            </div>

            <div class="h-100">
              <div v-if="tab==2" v-bar="{preventParentScroll: true}" class="h-100">
                <div>
                  <slot name="details-about"></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vuebar from "vuebar";
Vue.use(Vuebar);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import vueResource from "vue-resource";
Vue.use(vueResource);

export default {
  props: {
    alertMsg: {
      type: String,
      required: false,
      default:
        "Υποχρεωτικά cookies. Τα απαραίτητα cookies επιτρέπουν την εκτέλεση βασικών λειτουργιών του site."
    }
  },
  data() {
    return {
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
      showMsg: false,
      details: false,
      tab: 1,
      tabHor: 1,
      cookies: {
        necessary: true,
        statistics: false,
        marketing: true,
      }
    };
  },
  methods: {
    getMsgCookie() {
      return (
        this.$cookies.get("showCookiesMsg") == "true" ||
        this.$cookies.get("showCookiesMsg") == null
      );
    },
    setMsgCookie(value) {
    //   this.$cookies.set("showCookiesMsg", value, "1m");
      const component = this;
      var _url = "/en/cookies/consent?necessary="+component.cookies.necessary+"&statistics="+component.cookies.statistics;
      this.$http.get(_url).then(
        function(success) {
          console.log(success.data);
          component.showMsg = value;

          gtag('consent', 'update', {
                // standard
                'functionality_storage': 'granted',

                // Analytics
                'analytics_storage': component.cookies.statistics? "granted" : "denied",

                // ads
                'ad_storage': component.cookies.marketing?'granted':'denied',
                'ad_user_data': component.cookies.marketing?'granted':'denied',
                'ad_personalization': component.cookies.marketing?'granted':'denied',
                'personalization_storage': component.cookies.marketing?'granted':'denied',
                'security_storage': component.cookies.marketing?'granted':'denied',
            });
        },
        function(error) {
          console.log(error.data);
        }
      );
    },
    acceptAll() {
      const component = this;

      component.cookies.necessary = true;
      component.cookies.statistics = true;
      component.cookies.marketing = true;
      var _url = "/en/cookies/consent?necessary=true&statistics=true";
      this.$http.get(_url).then(
        function(success) {
          console.log(success.data);
          component.setMsgCookie(false);
          gtag('consent', 'update', {
                // standard
                'functionality_storage': 'granted',
                // Analytics
                'analytics_storage': "granted",

                // ads
                'ad_storage': component.cookies.marketing?'granted':'denied',
                'ad_user_data': component.cookies.marketing?'granted':'denied',
                'ad_personalization': component.cookies.marketing?'granted':'denied',
                'personalization_storage': component.cookies.marketing?'granted':'denied',
                'security_storage': component.cookies.marketing?'granted':'denied',
            });
        },
        function(error) {
          console.log(error.data);
        }
      );
    },
    toggleDetails() {
      this.details = !this.details;
    },
    alert(message) {
      window.alert(message);
    },
    onResize() {
      this.viewportWidth = window.innerWidth;
      this.viewportHeight = window.innerHeight;
    }
  },
  created() {
    window.addEventListener("resize", this.onResize, {
      passive: true
    });
  },
  mounted() {
    this.showMsg = this.getMsgCookie();
  }
};
</script>

<style scoped lang="scss">
#cookies-warning {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px 10px;
  background: rgba(#000, 0.8);
  color: #fff;
  text-align: center;
  z-index: 1000;
  transition: all 500ms ease-out;

  .btns {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 1px;
    display: flex;

    button {
      &:nth-child(1) {
        margin-right: 1px;
      }
    }
  }

  &.active {
    bottom: 40vh;
    background: rgba(#000, 1);
  }
}

.checkboxes {
  margin-top: 15px;

  .checkbox-wrapper {
    display: inline-block;
    position: relative;
    padding-top: 32px;
    padding-left: 0;
    cursor: pointer;
    font-size: 11px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    &:nth-child(1) {
      margin-right: 40px;
    }

    &:nth-child(2) {
      margin-left: 40px;
    }

    label {
      margin-bottom: 0px;
      cursor: pointer;

      .checkbox-text {
        font-size: 0.625rem;
        font-weight: 600;
        letter-spacing: 0.15rem;
      }
    }

    input {
      position: absolute;
      opacity: 0;
      visibility: hidden;
      cursor: pointer;
    }

    .checkbox {
      position: absolute;
      top: 0;
      left: 50%;
      height: 24px;
      width: 24px;
      background-color: transparent;
      border: 2px solid #fff;
      transform: translateX(-50%);

      &::after {
        content: "";
        position: absolute;
        display: none;
        left: 6px;
        top: 1px;
        width: 8px;
        height: 13px;
        border: solid #fff;
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
      }
    }

    &:hover input ~ .checkbox {
      background-color: transparent;
    }

    input:checked ~ .checkbox {
      background-color: transparent;
    }

    input:checked ~ .checkbox:after {
      display: block;
    }

    &.disabled {
      opacity: 0.5;
    }
  }
}

.btn-details {
  position: relative;
  margin-top: 10px;
  padding-left: 20px;
  padding-right: 17px;

  span {
    color: #fff;
    font-size: 0.6875rem;
    letter-spacing: 0.15rem;
  }

  &::before,
  &::after {
    content: "";
    display: block;
    position: absolute;
    top: calc(50% - 3px);
    width: 10px;
    height: 10px;
    border: solid #fff;
    border-width: 0px 2px 2px 0px;
    transform: rotate(45deg);
    transform-origin: center center;
    transition: all 250ms ease-out;
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }

  &.active {
    &::before {
      transform: rotate(225deg);
    }

    &::after {
      transform: rotate(-135deg);
    }
  }
}

.details {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(#000, 1);
  height: 40vh;

  .tabs {
    height: 100%;
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;

    .tabs-btns {
      display: flex;
      align-items: flex-end;

      .tab-btn {
        background: transparent;
        color: #fff;
        width: 50%;
        padding: 15px 10px;

        &.active {
          background: rgba(#fff, 0.2);
        }
      }
    }

    .tab-content {
      height: 34vh;
      padding: 2vh 2px;
      margin-top: 1px;
      color: #fff;
      border-radius: 0px 0px 0px 0px;
      background: rgba(#fff, 0.2);
    }
  }

  .tabs-hor {
    height: 100%;
    display: flex;
    justify-content: space-between;

    .tabs-hor-btns {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 12%;
      margin-right: 8%;

      .tab-btn-hor {
        color: #fff;
        width: 100%;
        text-align: left;
        padding: 6px 15px;
        margin-bottom: 5px;
        position: relative;

        &::after {
          content: "";
          display: block;
          opacity: 0;
          position: absolute;
          top: 0;
          left: 100%;
          width: 0;
          height: 0;
          border-top: 18px solid transparent;
          border-bottom: 18px solid transparent;
          border-left: 0px solid #fff;
          transition: all 250ms ease-out;
        }

        &.active {
          color: #000;
          background: #fff;

          &::after {
            opacity: 1;
            border-left: 8px solid #fff;
          }
        }
      }
    }

    .tab-content-hor {
      height: 100%;
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 76%;
    }
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 250ms ease-out;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.height-enter-active,
.height-leave-active {
  transition: all 500ms ease-out;
  overflow: hidden;
}

.height-enter,
.height-leave-to {
  max-height: 0px;
}

.height-leave,
.height-enter-to {
  max-height: 170px;
}

@media only screen and (max-width: 575px) {
  .checkboxes {
    .checkbox-wrapper {
      padding-top: 25px;

      .checkbox {
        height: 18px;
        width: 18px;

        &::after {
          width: 6px;
          height: 9px;
          border-width: 0px 2px 2px 0;
          left: 4px;
        }
      }
    }
  }

  .details {
    .tabs {
      .tabs-btns {
        .tab-btn {
          font-size: 0.66rem;
          padding: 10px 10px;
        }
      }
    }

    .tabs-hor {
      .tabs-hor-btns {
        margin-right: 6%;

        .tab-btn-hor {
          font-size: 0.625rem;
          padding: 2px 5px;
          margin-bottom: 1px;

          &::after {
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            border-left: 5px solid #fff;
          }
        }
      }
    }
  }
}

@media only screen and (max-height: 425px) {
  #cookies-warning {
    padding: 10px 10px;

    &.active {
      bottom: 30vh;
    }
  }

  .checkboxes {
    margin-top: 5px;
  }

  .details {
    height: 30vh;
  }

  .btn-details {
    margin-top: 0px;
  }
}
</style>